import React, { useState } from "react";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";

import { isEmpty, size, trim } from "lodash";

import { resetPasswordAction } from "@/actions/loginAction";
//import "../Orex.css";
import errorMessages from "@/constant/errorMessages";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { ToastContainer } from "react-toastify";
import { showSuccessMessage } from "@/utils/common";
import defaultValues from "@/constant/defaultValues";
import regExpression from "@/constant/regExpressions";
import Button from "@/components/Button";
import ConsentManager from "@/modules/frontend/components/ConsentManager";

import loginThumb from "@/assets/images/webp/login-thumb-bg.webp";


const Index = (props) => {
  let nav = useNavigate("");
  const [errors, setErrors] = useState({});
  const [password, setPassword] = useState();
  const [password_confirmation, setpassword_confirmation] = useState();
  const [showPassword, setshowPassword] = useState(false);
  const [showPassword1, setshowPassword1] = useState(false);
  const [searchParams, setsearchParams] = useSearchParams();

  let urlparameters = searchParams.get("token");
  let decodedUrlParam = atob(urlparameters);
  let z = decodedUrlParam.split("&email=");
  let token = z[0];
  let email = z[1];
  // console.log('token111', token);
  const { PASSWORD_FIELD_MAX_LENGTH } = defaultValues;
  const handleShowPassword = () => {
    setshowPassword(!showPassword);
  };

  const handleShowPassword1 = () => {
    setshowPassword1(!showPassword1);
  };

  // let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/; // for 8 to 15 chars only
  // let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/; // doesnt allow /,;. etc
  let regex = regExpression.pswd;

  const handleSubmit = async (e) => {
    e.preventDefault();
    //   console.log("test99", regex.test(password));
    if (!validation()) {
      await props
        .resetPassword(password, token, email, password_confirmation)
        .then((response) => {
          //   console.log("test", response);
          if (response === true) {
            showSuccessMessage("Password Changed Successfully");
            setTimeout(() => nav(publicRoutePaths.LOGIN.path), 1500);
            // nav(ROUTES.LOGIN);
          } else {
            const nerrors = {};

            if (!response.success) {
              // console.log('HERE1111111111111---', response);
              if (response.message === "Validation Error.") {
                if (!isEmpty(response.data.email)) {
                  nerrors.somethingWentWrong = "Something went wrong";
                }
                if (!isEmpty(response.data.password)) {
                  nerrors.password = response.data.password[0];
                }
                if (!isEmpty(response.data.password_confirmation)) {
                  nerrors.password_confirmation =
                    response.data.password_confirmation[0];
                }
              }
              if (response.message === "Invalid token or email.") {
                nerrors.invalidTokenOrEmail = response.message;
              }
              if (response.message === "Token has expired.") {
                nerrors.expiredToken = "Your Session has timed out";
              }
              if (
                response.message ===
                "New password cannot be the same as the old password."
              ) {
                nerrors.expiredToken = response.message;
              }
              if (!response) {
                nerrors.somethingWentWrong = "Something went wrong";
              }
            }

            setErrors(nerrors);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleKeyDown = (e) => {
    // console.log(e.code);
    if (e.code === "Space") {
      e.preventDefault();
    }
  };

  const validation = () => {
    const errors = {};
    if (password == "" || password == null) {
      errors.password = errorMessages.FIELD_REQUIRED;
    } else if (size(password) > PASSWORD_FIELD_MAX_LENGTH) {
      errors.password = errorMessages.MAX_CHARACTERS_REACHED;
    } else if (regex.test(password) == false) {
      errors.password = errorMessages.STRONG_PASSWORD;
    }

    if (password_confirmation == "" || password_confirmation == null) {
      errors.password_confirmation = errorMessages.FIELD_REQUIRED;
    } else if (size(password_confirmation) > PASSWORD_FIELD_MAX_LENGTH) {
      errors.password_confirmation = errorMessages.MAX_CHARACTERS_REACHED;
    } else if (password !== password_confirmation) {
      errors.password_confirmation = errorMessages.MATCH_PASSWORD;
    }

    setErrors(errors);
    return Object.keys(errors).length > 0;
  };

  const styleError = {
    display: "block",
  };

  const handleFocusOut = async (e) => {
    const verrors = { ...errors };
    if (e.target.name === "password") {
      const pwdVal = trim(e.target.value); 
      if (pwdVal == "" || pwdVal == null) {
        verrors.password = errorMessages.FIELD_REQUIRED;
      } else if (size(pwdVal) > PASSWORD_FIELD_MAX_LENGTH) {
        verrors.password = errorMessages.MAX_CHARACTERS_REACHED;
      } else if (regex.test(pwdVal) == false) {
        verrors.password = errorMessages.STRONG_PASSWORD;
      } else {
        verrors.password = "";
      }
    }

    if (e.target.name === "password_confirmation") {
      const pwdConfVal = trim(e.target.value);
      const pwdVal = trim(password); 
      if (pwdConfVal == "" || pwdConfVal == null) {
        verrors.password_confirmation = errorMessages.FIELD_REQUIRED;
      } else if (size(pwdConfVal) > PASSWORD_FIELD_MAX_LENGTH) {
        verrors.password_confirmation = errorMessages.MAX_CHARACTERS_REACHED;
      } else if (pwdVal !== pwdConfVal) {
        verrors.password_confirmation = errorMessages.MATCH_PASSWORD;
      } else {
        verrors.password_confirmation = "";
      }
    }

    setErrors(verrors);
    return Object.keys(verrors).length > 0;
  };

  return (
    <section className="registration-wrape login-page-wrape">
      <SeoHelmet
        title={seoConfig.resetPassword.title}
        description={seoConfig.resetPassword.description}
        keywords={seoConfig.resetPassword.keywords}
        author={seoConfig.resetPassword.author}
      />
      {/* <Header /> */}
      <div className="container">


        <div className="row">
          <div className="col-xxl-7 col-xl-6 col-lg-6 col-md-3 col-sm-12 "></div>
          <div className="col-xxl-5 col-xl-6 col-lg-6 col-md-9 col-sm-12 ">
            <div className="form-pad">
              <div className="section-head">
                {/* <div className="head"> */}
                {/* <p>
                Welcome to{" "}
                <img className="login-icon" src={loginIcoin} alt="" />
              </p> */}
                {/* <h2>
                <span>Reset</span> Password
              </h2> */}

                {/* </div> */}
                <div className="head">
                  <h2>
                    <span>Reset</span> Password
                  </h2>
                  <p className="text">
                    Your new password must be different from previously used passwords.
                  </p>
                  <img src={loginThumb} alt="Aero Plane" className="head-thumb" />
                </div>
              </div>

              {/* <div className="mt-4">
              <div className="d-flex align-items-center">
                <h3 className="login-title">Reset Password</h3>
                <img className="login-icon" src={loginIcoin} alt="" />
              </div>

              <p className="login-subtitle">
                Your new password must be different from previously used
                passwords
              </p>
            </div> */}
              <form id="account-detail">
                <div className="individual-error">
                  {errors.invalidTokenOrEmail && (
                    <div className="invalid-feedback" style={styleError}>
                      {errors.invalidTokenOrEmail}
                    </div>
                  )}
                  {errors.expiredToken && (
                    <div className="invalid-feedback" style={styleError}>
                      {errors.expiredToken}
                    </div>
                  )}
                  {errors.somethingWentWrong && (
                    <div className="invalid-feedback" style={styleError}>
                      {errors.somethingWentWrong}
                    </div>
                  )}
                </div>
                <div className="col-xxl-12">
                  <div className={`input-wrape big-error ${errors.password ? 'error-show' : ''}`}>

                    <div className="input-pad">
                      <input
                        type={showPassword === true ? "text" : "password"}
                        id="contact-form-email"
                        className="input"
                        autoComplete="new-off"
                        placeholder="Enter new password *"
                        onChange={(e) => setPassword(e.target.value)}
                        onBlur={handleFocusOut}
                        onKeyDown={handleKeyDown}
                        name="password"
                        value={password}
                      />
                      <span
                        className="input-group-text"
                        onClick={handleShowPassword}
                      >
                        <i className={
                          !showPassword
                            ? "fa-regular fa-eye"
                            : "fa-solid fa-eye-slash"
                        }
                        ></i>
                      </span>
                    </div>
                    {errors.password && (
                      <div className="invalid-feedback" style={styleError}>
                        {errors.password}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xxl-12">
                  <div className={`input-wrape ${errors.password_confirmation ? 'error-show' : ''}`}>
                    <div className="input-pad">
                      <input
                        type={showPassword1 === true ? "text" : "password"}
                        id="contact-form-email"
                        className="input"
                        autoComplete="new-off"
                        placeholder="Confirm new password *"
                        onChange={(e) =>
                          setpassword_confirmation(e.target.value)
                        }
                        onKeyDown={handleKeyDown}
                        onBlur={handleFocusOut}
                        name="password_confirmation"
                        value={password_confirmation}
                      />
                      <span
                        className="input-group-text"
                        onClick={handleShowPassword1}
                      >
                        <i className={
                          !showPassword1
                            ? "fa-regular fa-eye"
                            : "fa-solid fa-eye-slash"
                        }
                        ></i>
                      </span>
                    </div>
                    {errors.password_confirmation && (
                      <div className="invalid-feedback" style={styleError}>
                        {errors.password_confirmation}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  {/* <div className="col-xxl-6">
                    <span
                      className="login-text"
                      onClick={() => nav(publicRoutePaths.LOGIN.path)}
                    >
                      <img src={backArrow} alt="" />
                      Back to Login
                    </span>
                  </div> */}
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 inquiry-form-btn">
                    <Button
                      className="btn outline"
                      type="button"
                      onClick={() => nav(publicRoutePaths.LOGIN.path)}
                    >
                      Back to Login
                    </Button>
                    <Button
                      className="btn secondry-btn"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Save New Password
                    </Button>
                  </div>
                </div>

              </form>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
      <ConsentManager />
    </section>
  );
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth.login,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (password, token, email, password_confirmation) =>
      dispatch(
        resetPasswordAction(password, token, email, password_confirmation)
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
